import { render } from "./CopyrightItem.vue?vue&type=template&id=c0a5b176&scoped=true"
const script = {}

import "./CopyrightItem.vue?vue&type=style&index=0&id=c0a5b176&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a5b176"]])

export default __exports__